import { Schema } from 'mongoose';

export interface ILocalizedText {
  'en-us'?: string;
  en: string;
  ach?: string;
  ady?: string;
  af?: string;
  ak?: string;
  ar?: string;
  az?: string;
  bg?: string;
  bn?: string;
  ca?: string;
  cak?: string;
  cs?: string;
  cy?: string;
  da?: string;
  de?: string;
  dsb?: string;
  el?: string;
  eo?: string;
  es?: string;
  et?: string;
  eu?: string;
  fa?: string;
  ff?: string;
  fi?: string;
  fr?: string;
  ga?: string;
  gl?: string;
  he?: string;
  hi?: string;
  hr?: string;
  hsb?: string;
  ht?: string;
  hu?: string;
  id?: string;
  is?: string;
  it?: string;
  ja?: string;
  km?: string;
  kab?: string;
  kn?: string;
  ko?: string;
  la?: string;
  lb?: string;
  lt?: string;
  lv?: string;
  mai?: string;
  mk?: string;
  ml?: string;
  mr?: string;
  ms?: string;
  mt?: string;
  my?: string;
  no?: string;
  nb?: string;
  ne?: string;
  nl?: string;
  oc?: string;
  pa?: string;
  pl?: string;
  pt?: string;
  ro?: string;
  ru?: string;
  sk?: string;
  sl?: string;
  sq?: string;
  sr?: string;
  su?: string;
  sv?: string;
  sw?: string;
  ta?: string;
  te?: string;
  tg?: string;
  th?: string;
  tl?: string;
  tlh?: string;
  tr?: string;
  uk?: string;
  ur?: string;
  uz?: string;
  vi?: string;
  yi?: string;
  zh?: string;
}

const localizedSchema = new Schema(
  {
    // the only local to be required
    'en-us': {
      type: String,
    },
    en: {
      type: String,
      required: true,
    },
    ach: { type: String },
    ady: { type: String },
    af: { type: String },
    ak: { type: String },
    ar: { type: String },
    az: { type: String },
    bg: { type: String },
    bn: { type: String },
    ca: { type: String },
    cak: { type: String },
    cs: { type: String },
    cy: { type: String },
    da: { type: String },
    de: { type: String },
    dsb: { type: String },
    el: { type: String },
    eo: { type: String },
    es: { type: String },
    et: { type: String },
    eu: { type: String },
    fa: { type: String },
    ff: { type: String },
    fi: { type: String },
    fr: { type: String },
    ga: { type: String },
    gl: { type: String },
    he: { type: String },
    hi: { type: String },
    hr: { type: String },
    hsb: { type: String },
    ht: { type: String },
    hu: { type: String },
    id: { type: String },
    is: { type: String },
    it: { type: String },
    ja: { type: String },
    km: { type: String },
    kab: { type: String },
    kn: { type: String },
    ko: { type: String },
    la: { type: String },
    lb: { type: String },
    lt: { type: String },
    lv: { type: String },
    mai: { type: String },
    mk: { type: String },
    ml: { type: String },
    mr: { type: String },
    ms: { type: String },
    mt: { type: String },
    my: { type: String },
    no: { type: String },
    nb: { type: String },
    ne: { type: String },
    nl: { type: String },
    oc: { type: String },
    pa: { type: String },
    pl: { type: String },
    pt: { type: String },
    ro: { type: String },
    ru: { type: String },
    sk: { type: String },
    sl: { type: String },
    sq: { type: String },
    sr: { type: String },
    su: { type: String },
    sv: { type: String },
    sw: { type: String },
    ta: { type: String },
    te: { type: String },
    tg: { type: String },
    th: { type: String },
    tl: { type: String },
    tlh: { type: String },
    tr: { type: String },
    uk: { type: String },
    ur: { type: String },
    uz: { type: String },
    vi: { type: String },
    yi: { type: String },
    zh: { type: String },
  },
  { _id: false },
);

export default localizedSchema;

export type LanguageKeys = keyof ILocalizedText;
